module.exports = __webpack_public_path__ + "static/img/logo.026c4b59.png";